import { allowedImageFormats } from '@showbie-socrative/socrative-utils';

interface IsSupportedImageTypeParams {
  file: File;
  supportedImageFormats?: Array<string>;
}

export function isSupportedImageType({
  file: { type },
  supportedImageFormats = [...allowedImageFormats],
}: IsSupportedImageTypeParams) {
  return supportedImageFormats.includes(type);
}

export class UnSupportedImageTypeError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'UnSupportedImageTypeError';
  }
}
